const safeDecodeURIComponent = (value: string): string => {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

const normalizeRoutePath = (value?: string): string | undefined => {
  if (!value) return undefined

  const decoded = safeDecodeURIComponent(value.trim())
  const withLeadingSlash = decoded.startsWith('/') ? decoded : `/${decoded}`

  return withLeadingSlash !== '/' ? withLeadingSlash.replace(/\/+$/, '') : '/'
}

/**
 * Returns true if `pathname` is exactly `href` (when exact=true),
 * or if `pathname` equals `href` OR is a child route of it (segment boundary match).
 */
export const isRouteActive = (pathname: string, href?: string, exact = false): boolean => {
  const current = normalizeRoutePath(pathname) ?? '/'
  const target = normalizeRoutePath(href)

  if (!target) return false
  if (target === '/') return current === '/'

  if (exact) return current === target

  return current === target || current.startsWith(`${target}/`)
}
